var map = {
	"./faq.en.mdx": [
		5188,
		188
	],
	"./faq.zh.mdx": [
		9793,
		793
	],
	"./getting-started.en.mdx": [
		754,
		754
	],
	"./getting-started.zh.mdx": [
		2939,
		939
	],
	"./introducing.en.mdx": [
		7849,
		849
	],
	"./introducing.zh.mdx": [
		4488,
		488
	],
	"./manual.en.mdx": [
		7029,
		29
	],
	"./manual.zh.mdx": [
		844,
		844
	],
	"./opensource.en.mdx": [
		6828,
		828
	],
	"./opensource.zh.mdx": [
		2233,
		233
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5130;
module.exports = webpackAsyncContext;